import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'es',
  messages: {
    es: {
      alertState: {
        UNREAD: 'No leída',
        READ: 'Leída'
      },
      alertReason: {
        SPEED_OVER_80: 'Velocidad por encima de 80 km/h',
        MISSION_FAILED: 'Misión incumplida'
      }
    },
    en: {
      alertState: {
        UNREAD: 'Unread',
        READ: 'Read'
      },
      alertReason: {
        SPEED_OVER_80: 'Speed over 80 km/h',
        MISSION_FAILED: 'Mission failed'
      }
    }
  }
})
export default i18n



// WEBPACK FOOTER //
// ./src/utils/i18.js